import { downloadAsCsv } from 'utils/xmApiDownload';

export const LOAD_IMPORT_MESSAGES = 'LOAD_IMPORT_MESSAGES';
export const LOAD_IMPORT_MESSAGES_START = `${LOAD_IMPORT_MESSAGES}_START`;
export const LOAD_IMPORT_MESSAGES_SUCCESS = `${LOAD_IMPORT_MESSAGES}_SUCCESS`;
export const LOAD_IMPORT_MESSAGES_FAIL = `${LOAD_IMPORT_MESSAGES}_FAIL`;

export const PAGE = 'PAGE_IMPORT_MESSAGES';
export const PAGE_START = `${PAGE}_START`;
export const PAGE_SUCCESS = `${PAGE}_SUCCESS`;
export const PAGE_FAIL = `${PAGE}_FAIL`;

export const LOAD_IMPORT_PROBLEMS_COUNT = 'LOAD_IMPORT_PROBLEMS_COUNT';
export const LOAD_IMPORT_PROBLEMS_COUNT_START = `${LOAD_IMPORT_PROBLEMS_COUNT}_START`;
export const LOAD_IMPORT_PROBLEMS_COUNT_SUCCESS = `${LOAD_IMPORT_PROBLEMS_COUNT}_SUCCESS`;
export const LOAD_IMPORT_PROBLEMS_COUNT_FAIL = `${LOAD_IMPORT_PROBLEMS_COUNT}_FAIL`;

export const LOAD_IMPORT_ERROR_COUNT = 'LOAD_IMPORT_ERROR_COUNT';
export const LOAD_IMPORT_ERROR_COUNT_START = `${LOAD_IMPORT_ERROR_COUNT}_START`;
export const LOAD_IMPORT_ERROR_COUNT_SUCCESS = `${LOAD_IMPORT_ERROR_COUNT}_SUCCESS`;
export const LOAD_IMPORT_ERROR_COUNT_FAIL = `${LOAD_IMPORT_ERROR_COUNT}_FAIL`;

export const LOAD_IMPORT_WARNING_COUNT = 'LOAD_IMPORT_WARNING_COUNT';
export const LOAD_IMPORT_WARNING_COUNT_START = `${LOAD_IMPORT_WARNING_COUNT}_START`;
export const LOAD_IMPORT_WARNING_COUNT_SUCCESS = `${LOAD_IMPORT_WARNING_COUNT}_SUCCESS`;
export const LOAD_IMPORT_WARNING_COUNT_FAIL = `${LOAD_IMPORT_WARNING_COUNT}_FAIL`;

export const DOWNLOAD_CSV = 'DOWNLOAD_IMPORT_MESSAGES_CSV';
export const DOWNLOAD_CSV_START = `${DOWNLOAD_CSV}_START`;
export const DOWNLOAD_CSV_SUCCESS = `${DOWNLOAD_CSV}_SUCCESS`;
export const DOWNLOAD_CSV_FAIL = `${DOWNLOAD_CSV}_FAIL`;

const getUri = importId => `/webapi/xm/1/imports/${importId}/import-messages`;

const defaultParams = {
  offset: 0,
  limit: 100,
};

function apiLoadImportMessages(importJobId, type, params = {}) {
  return {
    type,
    meta: {
      xmApi: true,
      method: 'get',
      uri: getUri(importJobId),
      params: {
        ...defaultParams,
        ...params,
      },
    },
  };
}

/*
 * Currently used to populate data for (add if used elsewhere):
 * - ImportJobDetailsReport
 * - ImportJobProgressPopover
 */
export function loadImportMessages(importJobId, params) {
  return apiLoadImportMessages(importJobId, LOAD_IMPORT_MESSAGES, params);
}

export function getPage(nextLink) {
  return {
    type: PAGE,
    meta: {
      xmApi: true,
      method: 'get',
      uri: nextLink,
    },
  };
}

export function downloadAll(importJob, params = {}) {
  const { dataTransform, name, queryParams: queryParamsOverride } = params;
  const queryParams = {
    ...defaultParams,
    limit: 1000,
    ...queryParamsOverride,
  };

  return downloadAsCsv(getUri(importJob.id), {
    dataTransform,
    queryParams,
    fromObjects: false,
    type: DOWNLOAD_CSV,
    name,
  });
}
